"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _default = function _default(timeData, graphs) {
  // Make sure that all points have time, and time is always a number
  var _iterator = _createForOfIteratorHelper(timeData),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var sample = _step.value;
      if (sample.time === undefined || sample.time === null) throw new Error("Undefined time for sample\n\n".concat(JSON.stringify(sample)));

      if (typeof sample.time === "string") {
        var ogTime = sample.time;

        if (isNaN(ogTime)) {
          sample.time = new Date(sample.time).valueOf();
        } else {
          sample.time = parseFloat(sample.time);
        }

        if (isNaN(sample.time)) {
          throw new Error("Couldn't parse time \"".concat(sample.time, "\""));
        }
      }

      if (isNaN(sample.time)) throw new Error("Time must be a number");
    } // Make sure that timeData has a value in each datapoint for
    // each graph (or explicitly doesn't define it w/ undefined)
    // No NaNs allowed

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(graphs),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var graph = _step2.value;
      var pointsDefined = 0;

      var _iterator3 = _createForOfIteratorHelper(timeData),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _sample = _step3.value;
          var v = _sample[graph.keyName];
          if (v !== undefined && v !== null && isNaN(v)) throw new Error("Bad value for \"".concat(graph.keyName, "\": \"").concat(v, "\""));

          if (typeof v === "string") {
            _sample[graph.keyName] = parseFloat(v);
          }

          pointsDefined++;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (pointsDefined < 2) throw new Error("Less than two points defined for the \"".concat(graph.keyName, "\" graph"));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return timeData;
};

exports.default = _default;